"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCanceled = exports.isFailed = exports.isSucceeded = exports.isSubmitted = exports.isPending = void 0;

var RefundStatusTypes = _interopRequireWildcard(require("../constants/RefundStatusTypes"));

var isPending = function isPending(refund) {
  return refund && refund.get('status') === RefundStatusTypes.PENDING;
};

exports.isPending = isPending;

var isSubmitted = function isSubmitted(refund) {
  return refund && refund.get('status') === RefundStatusTypes.SUBMITTED;
};

exports.isSubmitted = isSubmitted;

var isSucceeded = function isSucceeded(refund) {
  return refund && refund.get('status') === RefundStatusTypes.SUCCEEDED;
};

exports.isSucceeded = isSucceeded;

var isFailed = function isFailed(refund) {
  return refund && refund.get('status') === RefundStatusTypes.FAILED;
};

exports.isFailed = isFailed;

var isCanceled = function isCanceled(refund) {
  return refund && refund.get('status') === RefundStatusTypes.CANCELED;
};

exports.isCanceled = isCanceled;